import React from 'react';
import { tokens } from '@veneer/tokens';

export const Subtitle = ({
  children,
  dataComponent = 'Subtitle',
  ...rest
}: React.HTMLAttributes<HTMLParagraphElement> & {
  children: React.ReactNode;
  dataComponent?: string;
}) => {
  return (
    <p
      data-component={dataComponent}
      {...rest}
      className={`subtitle-regular ${rest?.className || ''}`}
      style={{
        fontSize: tokens.typography.size4,
        ...rest.style,
        fontWeight: 400
      }}
    >
      {children}
    </p>
  );
};
